import classNames from "classnames";
import { withT } from "neetocommons/react-utils";
import { hyphenize } from "neetocommons/utils/general";
import { Typography } from "neetoui";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import "./breadcrumbs.scss";

const Breadcrumbs = withT(
  ({ t, breadcrumbs, hasTrailingSeparator = false, className }) => (
    <nav
      aria-label={t("neetoMolecules.breadcrumbs.breadcrumbAriaLabel")}
      className={classNames("neeto-molecules-breadcrumbs-wrap", className)}
    >
      <ol className="neeto-molecules-breadcrumbs-list">
        {breadcrumbs.map(({ text, link = "#" }, index) => {
          const isLast = index + 1 === breadcrumbs.length;
          const isCurrentPage = isLast && !hasTrailingSeparator;

          return (
            <li
              className="neeto-molecules-breadcrumb"
              data-testid="header-breadcrumb"
              key={index}
            >
              {isCurrentPage ? (
                <Typography
                  aria-current="page"
                  className="neeto-ui-text-gray-700 neeto-molecules-breadcrumb-link"
                  component="span"
                  data-testid={`${hyphenize(text)}-breadcrumb`}
                  style="body2"
                  weight="normal"
                >
                  {text}
                </Typography>
              ) : (
                <Link to={link}>
                  <Typography
                    className="neeto-ui-text-gray-700 hover:neeto-ui-text-gray-800 neeto-molecules-breadcrumb-link"
                    component="span"
                    data-testid={`${hyphenize(text)}-breadcrumb`}
                    style="body2"
                    weight="normal"
                  >
                    {text}
                  </Typography>
                </Link>
              )}
              {!isCurrentPage && (
                <span
                  aria-hidden="true"
                  className="neeto-molecules-breadcrumb-separator neeto-ui-text-black"
                >
                  /
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  )
);

Breadcrumbs.propTypes = {
  /**
   * To show breadcrumbs. `text` accepts a text string to be shown as the breadcrumb and `link` accepts relative URL path for the breadcrumb.
   */
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      link: PropTypes.string,
    })
  ),
};

export default Breadcrumbs;
